<template>
  <div class="jbot">
    <!-- <sub-header /> -->

    <article class="sub-body res_wrap px-3">
      <section class="sub-body-title">
        <h3 class="text-h4 text-sm-h2 font-weight-bold">JBot(RPA)</h3>
      </section>
      <section class="sub-body-content">
        
        <v-container fluid>
          <v-img contain :src="require('@/assets/img_sub_prod_jbot.png')" max-height="422"></v-img>
          <v-row class="align-stretch mt-8">
            <v-col cols="12" class="d-flex align-stretch">

              <v-card width="100%" class="px-4 pt-8 pb-10" outlined>
                <v-row class="align-stretch">
                  <v-col cols="12" sm="5">
                    <h5 class="text-h6 text-md-h5 font-weight-bold">JBot Enterprise의 구성</h5>
                    <ul class="list-type02 mt-2">
                      <li>자동화 업무를 정의하는 JBot Designer</li>
                      <li>업무 수행 결과를 모니터링 및 관리할 수 있는 Manager Web</li>
                      <li>자동화 업무를 수행하는 JBot Engine</li>
                      <li>스케줄링 실행, 즉시 실행, 그룹 실행이 가능하도록 하는 Server &amp; Client Daemon</li>
                    </ul>
                  </v-col>
                  <v-col cols="12" sm="7">
                    <h5 class="text-h6 text-md-h5 font-weight-bold">JBot의 특장점</h5>
                    <ul class="list-type02 mt-2">
                      <li><strong>사전 오류 검증</strong> : 로봇이 설치된 환경의 하드웨어, 소프트웨어를 비교하여 오류 발생 가능성 사전 체크</li>
                      <li><strong>타임 테이블 큐 기능</strong> : 스케줄링 실행, 즉시 실행, 그룹 실행, 인터페이스로 실행 등 다양한 실행 방법 제공</li>
                      <li><strong>공통 변수 공유 기능</strong> : JBot Manager에서 선언된 변수를 모든 로봇이 공유</li>
                      <li><strong>자동 로그 수집</strong> : 로봇 실행 진행 단계 로그, 오류 로그를 JBot Manager로 자동 수집</li>
                    </ul>
                  </v-col>
                </v-row>
              </v-card>

            </v-col>
          </v-row>
          <!-- <v-row class="mt-16 justify-center">
            <v-btn outlined x-large href="https://www.jbot.co.kr/" target="_blank">JBot Portal</v-btn>
          </v-row> -->

        </v-container>

      </section>
    </article>
  </div>
</template>

<script>
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export default {
  name: 'jbot',
  data() {
    return {
    };
  },

  created () {
  },

  mounted: function(){
    gsap.from(".jbot .sub-body-title", {
      scrollTrigger: {
        trigger: ".jbot .sub-body-title",
        toggleActions: "restart none none none",
      },
      duration: .6, y: -50, opacity: 0, stagger: .3,
    });
    gsap.from(".jbot .sub-body-content", {
      scrollTrigger: {
        trigger: ".jbot .sub-body-content",
        toggleActions: "restart none none none",
      },
      duration: 1, y: 50, opacity: 0, stagger: .3, delay: .3
    });
  },

  methods: {

  }

};
</script>

<style scoped>
</style>